import { api } from '../../../utils/client';
import type { CapabilityGridData, GridChange, GridScope } from './types';

export async function createCatalyxRole(name: string) {
  return api('/api/admin/roles/catalyx/', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function createClientRole(name: string) {
  return api('/api/admin/roles/client/', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function fetchCapabilityGrid(scope: GridScope) {
  return api<CapabilityGridData>(`/api/admin/capability-grid/${scope}/`);
}

export async function saveCapabilityGrid(scope: GridScope, changes: GridChange[]) {
  return api<{ updated: number; errors: number }>(`/api/admin/capability-grid/${scope}/`, {
    method: 'PATCH',
    body: JSON.stringify({ changes }),
  });
}
